import style from "./MotivationBar.module.css";

const MotivationBar = ({ label, value = 0 }) => {
  // Clamp value between 0 and 100
  const clampedValue = Math.max(0, Math.min(100, value));
  const percentage = clampedValue;

  return (
    <div className={style.barContainer}>
      <div className={style.barLabel}>{label}</div>
      <div className={style.barTrack}>
        <div 
          className={style.barFill}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};

export default MotivationBar;

